import React from 'react';
import clsx from 'clsx';
import IconLightMode from '@/assets/icons/icon-light-mode.svg?react';
import IconLightModeFilled from '@/assets/icons/icon-light-mode-filled.svg?react';
import IconDarkMode from '@/assets/icons/icon-dark-mode.svg?react';
import IconDarkModeFilled from '@/assets/icons/icon-dark-mode-filled.svg?react';
import { useTheme } from '@/context/ThemeProvider';

interface LightDarkModeProps {
  className?: string;
  'data-qa-selector'?: string;
}

export const LightDarkMode: React.FC<LightDarkModeProps> = ({
  className = '',
  'data-qa-selector': dataQaSelector,
}) => {
  const { darkMode, toggleDarkMode } = useTheme();

  const handleToggle = (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent event propagation in the editor
    toggleDarkMode(); // Toggle between light and dark mode
  };

  return (
    <div
      onClick={handleToggle} // Handle toggle on parent click
      className={clsx(
        'relative inline-flex h-8 w-16 cursor-pointer items-center justify-start rounded-[80px] bg-neutral-50 shadow-[inset_0px_0px_1.7777777910232544px_0px_rgba(0,0,0,0.12)]',
        className,
      )}
      data-qa-selector={dataQaSelector}
    >
      <div
        className={clsx(
          'bg-neutral-0 absolute h-[30px] w-[32px] rounded-[80px] outline-1 outline-neutral-100 transition-transform duration-300 ease-in-out',
          darkMode ? 'translate-x-[31px]' : 'translate-x-[1px]', // Smooth animation for toggle
        )}
      ></div>

      {/* Light Mode */}
      <div className="flex h-8 w-8 items-center justify-center gap-1">
        {!darkMode ? (
          <IconLightModeFilled className="relative z-5 h-4.5 w-4.5 text-neutral-900" />
        ) : (
          <IconLightMode className="relative z-5 h-4.5 w-4.5 text-neutral-400" />
        )}
      </div>

      {/* Dark Mode */}
      <div className="flex h-8 w-8 items-center justify-center gap-1">
        {darkMode ? (
          <IconDarkModeFilled className="relative z-5 h-4.5 w-4.5 text-neutral-900" />
        ) : (
          <IconDarkMode className="relative z-5 h-4.5 w-4.5 text-neutral-400" />
        )}
      </div>
    </div>
  );
};
